import type { ParticipanteBusquedaCandidate } from '../domain/participanteBusquedaCandidate.ts';
import type { ParticipanteSqlRow } from '../domain/participanteBusquedaLookupTypes.ts';

export function mapParticipanteSqlRowToBusquedaCandidate(row: ParticipanteSqlRow): ParticipanteBusquedaCandidate {
  return {
    id: Number(row.id ?? 0),
    nombre: String(row.nombre ?? '').trim(),
    documento: String(row.documento ?? '').trim(),
    comunaNombre: String(row.comuna_nombre ?? '').trim(),
  };
}
